import React from "react";
import { ArrowUpRightIcon } from "lucide-react";
import { solutions } from "../../data/home";
export function Solutions() {
  return <section id="placements" className="scroll-mt-24 bg-surface px-5 py-20 md:px-8 md:py-32" data-id="element-170" data-mp="2fqn9q40j48px">
      <div className="mx-auto max-w-7xl" data-id="element-171" data-mp="2atnbugdu2c9w">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-172" data-mp="26rjpuxtjfpad">
          <div className="max-w-2xl" data-id="element-173" data-mp="26twbbkyi8hs6">
            <p className="text-[15px] font-medium text-muted" data-id="element-174" data-mp="33i2h4b75xg81">Nos placements</p>
            <h2 className="mt-3 text-4xl font-semibold leading-[1.05] tracking-tightest md:text-6xl" data-id="element-175" data-mp="2yi7mpxo6i8i8">
              Les meilleures solutions du marché, choisies pour vous.
            </h2>
          </div>
          <a href="#contact" className="whitespace-nowrap self-start rounded-full border border-ink/15 bg-canvas px-6 py-3.5 text-[15px] font-medium transition-colors duration-150 hover:border-ink/40 md:self-auto" data-id="element-176" data-mp="2pqxnpque1k65">
            Trouver le bon placement
          </a>
        </div>

        <ul className="mt-14 border-t border-ink/10" data-id="element-177" data-mp="3i8503fbsmp6x">
          {solutions.map(s => <li key={s.name} data-id="element-178" data-mp="3n6g95nu9kvo3">
              <a href="#contact" className="group grid grid-cols-[1fr_auto] items-center gap-x-6 gap-y-2 border-b border-ink/10 py-7 md:grid-cols-[minmax(0,4fr)_minmax(0,6fr)_140px_48px] md:py-9" data-id="element-179" data-mp="3n5ncjfp0rmjo">
                <h3 className="text-2xl font-semibold tracking-tight transition-transform duration-200 ease-out group-hover:translate-x-1 md:text-3xl" data-id="element-180" data-mp="2zgvp11mdjsd8">
                  {s.name}
                </h3>
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-canvas transition-colors duration-150 group-hover:bg-ink group-hover:text-canvas md:order-last" data-id="element-181" data-mp="2pioa0obnbkdv">
                  <ArrowUpRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-182" data-mp="nr1rzc9qeztj" />
                </span>
                <p className="col-span-2 text-[17px] leading-relaxed text-muted md:col-span-1" data-id="element-183" data-mp="sq5z7xd3inh8">
                  {s.text}
                </p>
                <p className="col-span-2 text-sm font-medium text-ink/70 md:col-span-1" data-id="element-184" data-mp="ra0i4r5fqbls">
                  <span className="text-muted" data-id="element-185" data-mp="m9mk81xjsi1h">Horizon · </span>
                  {s.horizon}
                </p>
              </a>
            </li>)}
        </ul>
      </div>
    </section>;
}